<template>
  <div>
    <a-tabs 
      :default-active-key="key" v-model="key"
    >
      <a-tab-pane :key="1">
        <span slot="tab">
          <a-icon type="shop" />
          {{ $t('approvalRequest.shopVisitation') }}
        </span>
        <ShopRequest v-if="key == 1"/>
      </a-tab-pane>
      <a-tab-pane :key="2">
        <span slot="tab">
          <a-icon type="flag" />
          {{ $t('approvalRequest.communeVisitation') }}
        </span>
        <CommuneRequest v-if="key == 2"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import CommuneRequest from './commune-request-pending.vue'
import ShopRequest from './shop-request-checkin.vue'
export default {
  name: 'pending',
  components: {
    CommuneRequest,
    ShopRequest
  },
  data() {
    return {
      key: 1
    }
  },
}
</script>
